import { matchPath } from "react-router-dom";

/**
 * 하단 네비게이션 바를 노출할 경로 패턴 목록.
 * React Router 의 경로 패턴 문법을 그대로 사용한다.
 * - 정적 경로: "/tour" 는 정확히 "/tour" 일 때만 매칭된다.
 * - 동적 경로: "/tour/detail/:tourId" 는 "/tour/detail/123" 처럼 파라미터가 있는 경로에 매칭된다.
 *
 * 주의: 하단 네비의 '투어' 탭은 /tour(TourCalendarPage)로 이동하므로
 * /tour 가 목록에 없으면 투어 페이지에서 네비게이션이 사라진다.
 */
export const showBottomNavigationUrl = [
    "/",
    "/reservation",
    "/tour",
    // "/tour/list",
    // "/tour/detail/:tourId",
    "/shopping",
    "/mybuccl",
    "/community",
];

/**
 * 주어진 pathname 에서 하단 네비게이션을 노출해야 하는지 여부.
 * showBottomNavigationUrl 의 패턴 중 하나라도 일치하면 노출한다.
 * @param {string} pathname - location.pathname (쿼리스트링 제외)
 * @returns {boolean}
 */
export const shouldShowBottomNavigation = (pathname) =>
    showBottomNavigationUrl.some(
        (pattern) => matchPath(pattern, pathname) !== null
    );
